import { screeningAction } from '../../actions/constant';

const { GET_DISCIPLINE_TYPE_SUCCESS, GET_DISCIPLINE_TYPE_REQUEST, GET_DISCIPLINE_TYPE_FAILURE } =
  screeningAction;

const intitialstate: object = {
  response: null,
  isError: false,
  errorMessage: '',
};

export const getDisciplineTypeReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_DISCIPLINE_TYPE_SUCCESS: {
      return {
        ...state,
        isError: false,
        response: action.payload?.data,
      };
    }

    case GET_DISCIPLINE_TYPE_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
      };
    case GET_DISCIPLINE_TYPE_REQUEST:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
      };

    default:
      return state;
  }
};
